// TODO use material ui color palette
export enum ColorPalette {
  PRIMARY = '#666666',
  SECONDARY = '#999999',
  ACCENT = '#CCCCCC',
  LIGHT = '#EEEEEE',
  DARK = '#000000'
}
